<template>
  <div v-if="!isLoading && alertsArray.length > 0">
    <div class="info--text text-uppercase my-3 mt-2">
      {{ generateMessage('requests.details.titles.alerts') }}
    </div>
    <div>
      <v-simple-table
        dense
        class="secondarybackground caption text-center"
        :style="`max-width: ${alertsArray.length * 25}%`"
      >
        <thead>
          <tr class="font-weight-bold">
            <th v-for="item in alertsArray" :key="item.name">
              <div class="d-flex justify-center">
                {{ generateMessage(`alerts.fields.${item.name}`) }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="item in alertsArray" :key="item.name">
              <div class="d-flex justify-center my-1">
                <v-chip small class="mr-2">
                  {{ item.date | showDate }}
                </v-chip>
                <link-to-actionplan
                  v-if="item.plan"
                  color="success"
                  :actionPlanId="item.plan"
                />
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">
                      {{ generateMessage('alerts.icons.remove') }}
                    </v-icon>
                  </template>
                  <span>
                    {{
                      generateMessage('requests.details.titles.no_actionplan')
                    }}
                  </span>
                </v-tooltip>
              </div>

              <div>{{ item.desc }}</div>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { ALERTS_TYPES } from '@/services/services/alertsService';
import { mapGetters } from 'vuex';
import LinkToActionplan from '@/components/tools/LinkToActionplan';

export default {
  name: 'PropertyAlerts',
  components: { LinkToActionplan },
  methods: {
    generateMessage,
  },
  filters: {
    showDate(date) {
      return date.toLocaleDateString();
    },
  },
  computed: {
    ...mapGetters({
      alerts: 'properties/alerts/current',
      isLoading: 'properties/alerts/isLoadingCurrent',
    }),
    alertsArray() {
      if (this.alerts) {
        return ALERTS_TYPES.map((alert) => ({
          name: alert.desc,
          date: new Date(this.alerts[alert.date]),
          plan: this.alerts[alert.plan],
          desc: this.alerts[alert.desc],
        })).filter((alert) => alert.desc);
      }
      return [];
    },
  },
};
</script>
